let preSignupModalPromise = null;

export function loadPreSignupModal() {
  if (!preSignupModalPromise) {
    preSignupModalPromise = import("./PreSignupModal");
  }

  return preSignupModalPromise;
}

export function preloadPreSignupModal() {
  if (typeof window === "undefined") return null;
  return loadPreSignupModal();
}
